import React from "react"
import PropTypes from "prop-types"

// Components
import HeaderRow from "./HeaderRow"
import TableRow from "./TableRow"

const ScoreChart = props => {
  // Data
  const { data, keys } = props

  // Row Props
  const rowProps = {
    rowSpacing: {
      flex: `1 1 ${Math.floor((1 / keys.length) * 100)}%`
    },
    keys
  }
  return (
    <div className="scores-table">
      <HeaderRow {...rowProps} />
      {data.map(person => (
        <TableRow person={person} {...rowProps} key={Math.random()} />
      ))}
    </div>
  )
}

export default ScoreChart

ScoreChart.propTypes = {
  data: PropTypes.arrayOf(
    PropTypes.shape({
      elevate_person_id: PropTypes.string,
      name: PropTypes.string,
      riskScore: PropTypes.number,
      department: PropTypes.string
    })
  ),
  keys: PropTypes.arrayOf(PropTypes.string)
}

ScoreChart.defaultProps = {
  data: [{}],
  keys: ["name", "riskScore", "department"]
}
